import { render, staticRenderFns } from "./configSetTem.vue?vue&type=template&id=73d4a380&scoped=true"
import script from "./configSetTem.vue?vue&type=script&lang=js"
export * from "./configSetTem.vue?vue&type=script&lang=js"
import style0 from "./configSetTem.vue?vue&type=style&index=0&id=73d4a380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d4a380",
  null
  
)

export default component.exports